import { IPoint } from 'framework/utils/math-utils';
import { IHexGridData } from 'js/bubbleCore/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';

export function gridOffsetToSpaceOffset<T>(grid: IHexGridData<T>): IPoint {
  const point = {x: 0, y: 0};
  if (isPointyTop(grid.type)) {
    point.x += Math.sqrt(3) * grid.offset.x;
    point.y += grid.offset.y * 2;
  } else {
    point.x += grid.offset.x * 2;
    point.y += Math.sqrt(3) * grid.offset.y;
  }
  return point;
}